import axios from '@/axiosConnection'
import toastr from '@/toastr'

export default {
  namespaced: true,
  state: {
    items: [],
    // Vocabulaires servis par l'API : ils vivent côté back (LocationForAccountConstant), pas
    // en double ici — une valeur ajoutée là-bas doit apparaître sans toucher au front.
    options: {
      fieldTypes: {},
      fieldTypesWithValues: []
    }
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
    // Types de champ, au format attendu par les <select> du back-office.
    getFieldTypesForSelect: state => Object.entries(state.options.fieldTypes || {})
      .map(([value, text]) => ({ value, text })),
    getFieldTypeLabel: state => type => (state.options.fieldTypes || {})[type] || type,
    // Choix multiple et boutons radio n'ont aucun sens sans liste de valeurs.
    needsChoices: state => type => (state.options.fieldTypesWithValues || []).indexOf(type) >= 0,
    // Attributs proposables à l'activation sur une fiche produit : les actifs seuls.
    getActiveForSelect: state => state.items.filter(item => item.active)
      .map(item => ({ value: item.id, text: item.label }))
  },
  mutations: {
    setOptions(state, options) {
      state.options = { ...state.options, ...options }
    }
  },
  actions: {
    /**
     * Charge les vocabulaires fermés du module (types de champ, catégories de frais).
     * Ils sont servis par l'API plutôt que recopiés ici : une valeur ajoutée côté back doit
     * apparaître sans toucher au front.
     */
    getOptions(context) {
      return axios.get('requestattribute/options')
        .then(response => {
          if (response && response.data) {
            context.commit('setOptions', response.data)
          }
          return response
        })
        .catch(error => {
          toastr.error("Le chargement des options a échoué")
          return Promise.reject(error)
        })
    },
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'requestattribute',
        api_data_path: 'requestAttributes',
        namespace: 'request_attribute'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'requestattribute',
        namespace: 'request_attribute',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'requestattribute',
        namespace: 'request_attribute',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'requestattribute',
        namespace: 'request_attribute',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'requestattribute',
        namespace: 'request_attribute',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/request_attribute.js